/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_forgottPasswordCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {

        $scope.success = function (msg) {
            Notification.success(msg);
        };
        $scope.error = function (msg) {
            Notification.error(msg);
        };



        $scope.sendPasswordResetEmail = function ()
        {
            NetworkService.sendPasswordResetEmail($scope.email, function (data) {
                if (data.done)
                {
                    $scope.success("Bitte schau in deinen E-Mails nach, und klick dort auf den Bestätigungslink")
                } else
                {
                    if (data.error == 21)
                    {
                        $scope.error("Die E-Mail Adresse existiert nicht")
                    } else
                    {
                        $scope.error("Es gab einen Fehler")
                    }
                }
            })



        }


    }])